import styled from 'styled-components';

export const SWrapper = styled.div``;
